import { useExperimentsEligibleProps } from '@seek/candidate-feature-flag';
import { useContext, useEffect } from 'react';

import AnalyticsContext from 'src/analytics/AnalyticsContext';
import type { SetExperiments } from 'src/analytics/adapter';
import type { RecommendedJobsAnalytics } from 'src/analytics/adapter/recommendedJobs';
import type { SavedSearchesAnalytics } from 'src/analytics/adapter/savedSearches';

const useSetExperiments = (setFunction: SetExperiments['setExperiments']) => {
  const {
    tealiumEligibleProps: { experimentsEligible, hubbleExperiments },
  } = useExperimentsEligibleProps();

  useEffect(() => {
    if (experimentsEligible?.length) {
      setFunction({ experimentsEligible, hubbleExperiments });
    }
  }, [setFunction, experimentsEligible, hubbleExperiments]);
};

export const useSetRecsExperiments = () => {
  const { setExperiments } = useContext(
    AnalyticsContext,
  ) as RecommendedJobsAnalytics;

  useSetExperiments(setExperiments);
};

export const useSetSavedSearchesExperiments = () => {
  const { setExperiments } = useContext(
    AnalyticsContext,
  ) as SavedSearchesAnalytics;

  useSetExperiments(setExperiments);
};
